module.exports = __webpack_public_path__ + "static/media/user-magnifying.fcac2df1.svg";